import { render, staticRenderFns } from "./AddProgramButton.vue?vue&type=template&id=8b9f7958&scoped=true&"
import script from "./AddProgramButton.vue?vue&type=script&lang=ts&"
export * from "./AddProgramButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddProgramButton.vue?vue&type=style&index=0&id=8b9f7958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f7958",
  null
  
)

export default component.exports